import BaseLP from 'services/sports/default/base-lp';

export default class LpTiers extends BaseLP {
    subjectToPermanent() {
        const constraints = {
            tiers: this.exec('prepareSectionByTier', {}, ''),
        };

        return {...constraints};
    }

    subjectToAlterable() {
        const constraints = {
            createdLineups: this.exec('prepareSectionByCreatedLineups', {}, ''),
            exposureMax: this.exec('prepareSectionByExposureMax', {}, ''),
            exposureMin: this.exec('prepareSectionByExposureMin', {}, ''),
            playerCombinationStacking: this.exec('playerCombinationStacking', {}, ''),
        };

        return {...constraints};
    }
}
